<template>
  <div>

    <div class='calendar-container border-bottom'>

      <div id="calendar-swiper-container"
           class="swiper-container padding-top">
        <div class="swiper-wrapper">
          <dsCalendarItem v-for='item in orderedList'
                          :item="item"
                          :language="language"></dsCalendarItem>
        </div>
      </div>

      <div class="calendar-nav">
        <span class="button-prev secondary-color">&#60;</span>
        <span class="button-next secondary-color">&#62;</span>
      </div>

    </div>

  </div>
</template>

<script>
import dsCalendarItem from './dsCalendarItem'
import Swiper from 'swiper'
import moment from 'moment'

export default {
  name: 'dsCalendar',
  calendarSlideShow: {},
  components: {
    dsCalendarItem
  },
  props: ['language', 'posts'],
  mounted() {
    this.calendarSlideShow = new Swiper('#calendar-swiper-container', {
      speed: 500,
      autoplay: false,
      loop: false,
      spaceBetween: 30,
      nextButton: '.button-next',
      prevButton: '.button-prev'
    })
  },
  computed: {
    orderedList() {
      let list = []
      var currentCounter = 0
      if (this.posts) {
        this.posts.forEach(event => {
          if (event.acf.dates) {
            event.acf.dates.forEach(date => {
              const nlDate = moment(date.date)
              const enDate = moment(date.date)
              nlDate.locale('nl')
              enDate.locale('en')
              let tempObj = {
                slug: event.slug,
                title: event.title.rendered,
                title_en: event.acf.title_en,
                fullDate: date.date,
                date: nlDate.format('DD')
              }
              tempObj.en = {
                month: enDate.format('MMM'),
                day: enDate.format('ddd')
              }
              tempObj.nl = {
                month: nlDate.format('MMM'),
                day: nlDate.format('ddd')
              }
              if (moment().isBefore(nlDate)) {
                currentCounter++
              }
              list.push(tempObj)
            })
          }
        })
        list.sort((a, b) => {
          if (a.fullDate < b.fullDate) {
            return -1
          } else if (a.fullDate > b.fullDate) {
            return 1
          } else {
            return 0
          }
        })
        return list.slice(-currentCounter)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';
@import '../styles/vendor/swiper.css';

.calendar-container {
  height: 16 * $baseline;
  position: relative;
}

.calendar-nav {
  height: 2 * $baseline;
  position: absolute;
  z-index: 1000;
  bottom: 0;
  pointer-events: all;
  span {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// dsCalendar.vue?afd2070c